import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function DreamTooDifficultSymbol() {
    return (
        <span className={styleClass} data-tip="This dream is too difficult">
            <Glyphicon icon={EGlyphicon.bishop} />
        </span>
    );
}

const styleClass = StyleClass(`dreamTooDifficultSymbol`, {
    color: `coral`,
    opacity: 0.4,
});
